import { Component } from '@angular/core';

/**
 * Component
 */
@Component({
  selector: 'app-accountdisabled',
  templateUrl: './accountdisabled.component.html',
  styleUrls: ['./accountdisabled.component.scss']
})
export class AccountdisabledComponent {

}
